import { gql } from "@apollo/client";

export const EVENT_TEMPLATE_FRAGMENT = gql`
  fragment EventTemplate on EventTemplate {
    id
    ageLimit
    date
    doorTime
    name
    publishAt
    sendTicketsAt
    status
    type
    venueId
    youtubeUrl
    description
    ticketDescription
    timezone
    recurringSettingsId
  }
`;
